import { deliveryGroupColumns as columns } from './tableColumns'
import { cx, css } from 'emotion'

import MainTableDeliveryGroupRow from '@/components/Advertiser/Report/StandardReport/MainTableDeliveryGroupRow'

const MainTableDeliveryGroupRows = ({ props }) => {
  const { deliveryGroupReports, isHideRevenue } = props

  const backgroundBase3 = css`
    background: white;
  `

  const headerStyles = cx('campaign__header', 'pointer', backgroundBase3)
  const iconStyles = sortValue => {
    return sortValue === deliveryGroupReports.sortBy &&
      deliveryGroupReports.sortDirection
      ? 'reverse'
      : null
  }
  const filteredData = deliveryGroupReports.sortedItems

  return [
    <tr>
      {(isHideRevenue
        ? columns.filter(
            c => !['予算', '消化金額', 'CTR', 'CPC'].includes(c.title),
          )
        : columns
      ).map((column, index) => (
        <th key={index} class={[headerStyles, {}]}>
          {column.sort.able && (
            <div
              onClick={() => deliveryGroupReports.changeSort(column.sort.value)}
            >
              <v-icon small class={iconStyles(column.sort.value)}>
                arrow_downward
              </v-icon>
            </div>
          )}
        </th>
      ))}
    </tr>,
    ...filteredData.map(deliveryGroupReport => (
      <MainTableDeliveryGroupRow
        deliveryGroupReport={deliveryGroupReport}
        isHideRevenue={isHideRevenue}
      />
    )),
  ]
}

export default MainTableDeliveryGroupRows
